module.exports = __webpack_public_path__ + "img/medal5.b8e2c2fb.png";